module.exports = __webpack_public_path__ + "static/media/eple_red-min.e2fdc6d7.png";